import { createAction, createReducer } from "redux-act";
import { push } from "react-router-redux";
import { pendingTask, begin, end } from "react-redux-spinner";
import { notification } from "antd";
import axios from "axios/";
import UserService from "../services/userService/";
import * as Consts from "../config";
import { loadUserFailure, logoutSuccess, logoutRequest } from "./data";
import { parseError } from "../epics/lib";
import merge from "lodash/merge";
import assign from "lodash/assign";

const REDUCER = "app";
const _ = require("lodash");

export const NS = `@@${REDUCER}/`;

const _setFrom = createAction(`${NS}SET_FROM`);
const _setLoading = createAction(`${NS}SET_LOADING`);
const _setHideLogin = createAction(`${NS}SET_HIDE_LOGIN`);

export const setUserState = createAction(`${NS}SET_USER_STATE`);
export const errorHandles = createAction(`${NS}ERROR_HANDLED`);
export const setUpdatingContent = createAction(`${NS}SET_UPDATING_CONTENT`);
export const setActiveDialog = createAction(`${NS}SET_ACTIVE_DIALOG`);
export const deleteDialogForm = createAction(`${NS}DELETE_DIALOG_FORM`);
export const addSubmitForm = createAction(`${NS}ADD_SUBMIT_FORM`);
export const deleteSubmitForm = createAction(`${NS}DELETE_SUBMIT_FORM`);
export const setLayoutState = createAction(`${NS}SET_LAYOUT_STATE`);

export const setLoading = isLoading => {
  const action = _setLoading(isLoading);
  action[pendingTask] = isLoading ? begin : end;
  return action;
};

export const resetHideLogin = () => (dispatch, getState) => {
  const state = getState();
  if (state.pendingTasks === 0 && state.app.isHideLogin) {
    dispatch(_setHideLogin(false));
  }
  return Promise.resolve();
};

export const initAuth = roles => (dispatch, getState) => {
  // Use Axios there to get User Data by Auth Token with Bearer Method Authentication
  let roles = window.localStorage.getItem("app.Roles");
  const userRoles = roles ? roles.split(",") : [];
  const userId = window.localStorage.getItem("app.UserId");
  const state = getState();

  const setUser = (userState, userRole) => {
    new UserService()
      .find(userId)
      .then(response => {
        dispatch(
          setUserState({
            userState: {
              ...response.data.data,
              roles: userRoles
            }
          })
        );
      })
      .catch(error => {
        return loadUserFailure(parseError(error));
      });

    return Promise.resolve(true);
  };
  if (_.intersection(Consts.UserPermissions.All, userRoles).length > 0) {
    return setUser(null, userRoles);
  } else {
    const location = state.routing.location;
    const from = location.pathname + location.search;
    dispatch(_setFrom(from));
    dispatch(push("/login"));
    return Promise.reject();
  }
};

export function login(username, password, dispatch) {
  return false;
}

export const logout = () => (dispatch, getState) => {
  dispatch(logoutRequest());
};

const initialState = {
  // APP STATE
  from: "",
  isUpdatingContent: false,
  isLoading: false,
  activeDialog: "",
  dialogForms: {},
  submitForms: {},
  isHideLogin: false,

  // LAYOUT STATE
  layoutState: {
    isMenuTop: false,
    menuMobileOpened: false,
    menuCollapsed: false,
    menuShadow: false,
    themeLight: true,
    squaredBorders: false,
    borderLess: true,
    fixedWidth: false,
    settingsOpened: false
  },
  // USER STATE
  userState: {
    attributes: {}
  }
};

export default createReducer(
  {
    [_setFrom]: (state, from) => ({ ...state, from }),
    [_setLoading]: (state, isLoading) => ({ ...state, isLoading }),
    [_setHideLogin]: (state, isHideLogin) => ({ ...state, isHideLogin }),
    [setUpdatingContent]: (state, isUpdatingContent) => ({
      ...state,
      isUpdatingContent
    }),

    [setUserState]: (state, { userState }) => {
      let newState = { ...state, userState };
      return newState;
    },
    [setLayoutState]: (state, param) => {
      const layoutState = { ...state.layoutState, ...param };
      const newState = { ...state, layoutState };
      window.localStorage.setItem(
        "app.layoutState",
        JSON.stringify(newState.layoutState)
      );
      return newState;
    },
    [setActiveDialog]: (state, activeDialog) => {
      const result = { ...state, activeDialog };
      if (activeDialog && activeDialog !== "") {
        const id = activeDialog;
        result.dialogForms = { ...state.dialogForms, [id]: true };
      } else {
        result.submitForms = {};
      }
      return result;
    },
    [deleteDialogForm]: (state, id) => {
      const dialogForms = { ...state.dialogForms };
      delete dialogForms[id];
      return { ...state, dialogForms };
    },
    [addSubmitForm]: (state, data) => {
      let type = data.type;
      let form = state.submitForms[type]
        ? state.submitForms[type].attributes
        : {};
      data = assign({}, state.submitForms[type], data);
      data.attributes = assign({}, form, data.attributes);
      const submitForms = {
        ...state.submitForms,
        [type]: assign({}, state.submitForms[type], data)
      };
      return { ...state, submitForms };
    },
    [deleteSubmitForm]: (state, id) => {
      const submitForms = { ...state.submitForms };
      delete submitForms[id];
      return { ...state, submitForms };
    },
    [logout]: (state, id) => {
      return { ...initialState };
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/ducks/app.js